import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import "./style.css";

const DriverPartnerExpandableEle = ({ expandableData }) => {
	const [expanded, setExpanded] = useState(0);
	const [timerActive, setTimerActive] = useState(true);
	const intervalRef = useRef(null);

	const startTimer = (force = false) => {
		if (!timerActive && !force) return;
		setTimerActive(true);

		intervalRef.current = setInterval(() => {
			if (!timerActive) {
				clearInterval(intervalRef.current);
				return;
			}
			setExpanded((prevExpanded) => (prevExpanded + 1) % 5);
		}, 3000);
	};

	const stopTimer = () => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
			intervalRef.current = null;
		}
		setTimerActive(false);
	};

	useEffect(() => {
		if (timerActive) {
			startTimer();
		}

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [expandableData, timerActive]);

	return (
		<div className="driver_partner_expandable_divs">
			{expandableData?.map((a, i) => (
				<div
					key={i}
					className={`expandable_div ${
						expanded == i ? "active_expandable_div" : ""
					}`}
					onClick={() => {
						setExpanded(i);
					}}
					onMouseEnter={stopTimer}
					onMouseLeave={() => {
						startTimer(true);
					}}
				>
					<div>
						<span>0{i + 1}</span>
						<div className="expanded_div">
							<Image
								src={a?.iconUrl}
								width={80}
								height={0}
								alt="zevo-image"
							/>
							<p>{a?.text}</p>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default DriverPartnerExpandableEle;
